import { Box, Text } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Text,
  React
};